import APIClient from '@/shared/http/clients/api'

const resourceName = 'comarca'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nome,asc&size=500`, data, config)
const GetAllActive = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?inative=0&sort=nome,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${document}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)

const ComarcaRepository = {
  GetAll,
  GetAllActive,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  ChangeStatus
}

export default ComarcaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/comarca.js